import React from "react";
import { Section } from "../Container/Section";
import { SectionTitleWithExp } from "../customTypo/SectionTitleWithExp";
import { CardContainerRetro } from "../Container/CardContainerRetro";
import { Grid, Text } from "@mantine/core";
import colorsCustom from "../../designTokens/colorsCustom";
import { useTranslation } from "react-i18next";
import { trackEvent } from "../../utils/analytics";
import { useFriendsInteractionData } from "../../hooks/useThreadsSelector";
import { GridSkeleton } from "../skeleton/GridSkeleton";
import { useIsMobile } from "../../hooks/useIsMobile";
import { FriendInteractionCard } from "../Card/FriendInteractionCard";

export const TopFriendsSection = ({ onUserClick }) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile("xl");

  // ThreadsContext에서 친구 상호작용 데이터 가져오기
  const {
    repliesByUser,
    isRepliesLoading,
    isProcessing,
    isDataReady,
    error
  } = useFriendsInteractionData();

  // 에러 처리
  if (error && repliesByUser.length === 0) {
    return null; // 에러시 섹션 숨김
  }

  // 로딩 중
  if (isRepliesLoading || isProcessing || !isDataReady) {
    return (
      <GridSkeleton title={t("topActiveFriends")} />
    );
  }

  // 첫 번째 항목(나 자신) 제거하고 상위 5명 선택
  const topFriends = repliesByUser ? repliesByUser.slice(1, 6) : [];

  // 데이터가 없는 경우 섹션 숨김
  if (!repliesByUser || repliesByUser.length === 0 || topFriends.length === 0) {
    return null;
  }

  return (
    <Section>
      <SectionTitleWithExp title={t("topActiveFriends")} />
      <Text c="dimmed" size="lg" mb="16px">
        {t("topActiveFriendsDescription")}
      </Text>
      <CardContainerRetro
        p={isMobile ? "16px" : "24px"}
        bg={colorsCustom.paper}
        weight="bold"
        rd={16}
        mb="24px"
      >
        <Grid w="100%" wrap="wrap" gutter="16px">
          {/* 1위 - 1/2 공간 차지 */}
          <Grid.Col span={isMobile ? 12 : 6}>
            <FriendInteractionCard
              rank={1}
              user={topFriends[0]}
              size="large"
              isMobile={isMobile}
              style={{ height: "100%" }}
              onClick={() => {
                if (onUserClick) {
                  onUserClick(topFriends[0].username);
                }
                trackEvent("Reply_By_Friends_Clicked", {
                  username: topFriends[0].username,
                });
              }}
            />
          </Grid.Col>

          {/* 2-5위 - 2X2 Grid */}
          <Grid.Col span={isMobile ? 12 : 6}>
            <Grid w="100%" gutter="12px">
              {topFriends.slice(1, 5).map((user, index) => (
                <Grid.Col span={6} key={user.username}>
                  <FriendInteractionCard
                    rank={index + 2}
                    user={user}
                    size="small"
                    isMobile={isMobile}
                    onClick={() => {
                      if (onUserClick) {
                        onUserClick(user.username);
                      }
                      trackEvent("Reply_By_Friends_Clicked", {
                        username: user.username,
                      });
                    }}
                  />
                </Grid.Col>
              ))}
            </Grid>
          </Grid.Col>
        </Grid>
      </CardContainerRetro>
    </Section>
  );
}; 